import SchemaHandler from '@exp/exp-utils/schema/schemaHandler';
import { merge } from '@exp/exp-utils/helper/object';
import { getISODate } from '@exp/exp-utils/helper/date';
import { pushEvent } from '@tcc/shared/src/integrations/eventBus/eventBus';
import globalContext from '../globalContext';
import config from '@exp/exp-utils/helper/config';

class BaseEventHandler extends SchemaHandler {

  process(sinkFnMap) {
    super.process(merge({
      ALL: () => { this._handleEventBus(); }
    }, sinkFnMap));
  }

  _handleEventBus() {
    const events = this._getEvents();
    if (!events || events.length === 0)
      return;

    const eventCreationTimestamp = getISODate();
    for (let i = 0; i < events.length; i++) {
      events[i].data = merge({ eventCreationTimestamp }, events[i].data);
    }

    globalContext.updateContext();

    pushEvent({
      apiKey: this._getApiKey(),
      schemaId: this._getSchemaId(),
      globalContext: globalContext.context,
      contextVersion: globalContext.version,
      businessContext: this._getBusinessContext(),
      events
    });
  }

  // Abstract method (Required)
  _getEvents() {}

  // Override method (Optional)
  _getSchemaId() {
    return 'urn:shared:user:events:/v1';
  }

  // Override method (Optional)
  _getBusinessContext() {}

  // Override method (Optional)
  _getApiKey() {
    return config.get('tcc.eventBusApiKey');
  }
}

export default BaseEventHandler;
